"use strict";
import noop from "utilities/src/react/noop";
export const dismissNativeKeyboard = noop;
